<template>
  <div class="billing-date">
    <div class="previous-billing-date">{{ previousBillingDate }}</div>
    <div class="new-billing-date">{{ currentBillingDate }}</div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import moment from 'moment';

export default {
  name: 'FreeMonthsBillingDate',
  computed: {
    ...mapState('subscription', ['firstBillingDate']),
    ...mapState('benefits', ['benefitAmount']),
    ...mapGetters('benefits', ['BENEFIT_TYPES']),
    previousBillingDate() {
      return moment(this.firstBillingDate).subtract(this.benefitAmount, 'month').format('D.M.YY');
    },
    currentBillingDate() {
      return moment(this.firstBillingDate).format('D.M.YY');
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '~base-ui/src/scss/riseup-colors';
  @import '../../../../../scss/mixins';

  .billing-date {
    display: flex;
    font-size: 20px;
    padding: 11px 0 12px;
    line-height: 1;
    .previous-billing-date {
      color: #a19d9d;
      text-decoration-line: line-through;
      margin-left: 12px;
    }
    .new-billing-date {
      font-weight: bold;
    }
  }
</style>
